import { getResearchAreaLabel, isResearchAreaSlug } from "@/lib/taxonomy/research-areas";

type CategoryName = {
	slug?: string | null;
	name?: string | null;
	translation?: { name?: string | null } | null;
};

export function getLocalizedCategoryName(category: CategoryName, locale: string): string {
	if (category.slug && isResearchAreaSlug(category.slug)) {
		return getResearchAreaLabel(category.slug, locale);
	}

	return category.translation?.name || category.name || category.slug || "";
}
